import clsx from 'clsx';
import { IconType } from 'react-icons';

interface Props {
  className?: string;
  icon: React.ReactNode | IconType;
  children: React.ReactNode;
}

function IconBulletPointItem({
  className,
  icon,
  children,
}: Props): JSX.Element {
  const Icon = icon as IconType;
  return (
    <div className={clsx('relative pl-9', className)}>
      <div className="absolute left-0">
        {typeof icon === 'function' ? (
          <Icon className="h-6 w-6 text-green-500" />
        ) : (
          icon
        )}
      </div>
      <div className="text-gray-600">{children}</div>
    </div>
  );
}

export default IconBulletPointItem;
